import React from 'react';
import PropTypes from 'prop-types';
import HeaderComponent from 'components/HeaderComponent';
import styled from 'styled-components';
import { Card, CardHeader, CardContent, Box } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
// import { Creators as ChildrenCreators } from 'store/ducks/children';
import moment from 'moment';
import { appColors } from 'utils/appColors';

import LoadingIndicator from 'components/LoadingIndicator';
import { push } from 'connected-react-router';

const StyledBoxImg = styled('img')`
  && {
    max-height: 120px;
    max-width: 120px;
  }
`;

const ChildrenView = ({ clientId }) => {
  const dispatch = useDispatch();

  const { children, childrenLoading } = useSelector(state => state.children);

  const translateGenre = genre => {
    return genre === 'M' ? 'Masculino' : 'Feminino';
  };

  const translateDate = date => {
    return moment(date).format('DD/MM/YYYY') !== 'Invalid date'
      ? moment(date).format('DD/MM/YYYY')
      : 'Não preenchida';
  };

  const handleBack = () => {
    dispatch(push(`/clients/view/${clientId}`));
    // dispatch(push(`/son`));
  };

  return (
    <>
      <div>
        <HeaderComponent goBack={handleBack} />
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          flexWrap="wrap"
          alignItems="stretch"
          marginLeft={-1}
          marginRight={-1}
        >
          <Box flexGrow={1} p={1}>
            {childrenLoading && Object.keys(children).length === 0 && (
              <LoadingIndicator />
            )}
            {Object.keys(children).length > 0 && !childrenLoading && (
              <Card
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  height: '100%',
                }}
              >
                {console.log(children)}
                <CardHeader title="Dados do filho (a)" />
                <CardContent
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  {children.images.original !== '' && (
                    <StyledBoxImg src={children.images.original} />
                  )}
                  {children.images.original === '' && (
                    <StyledBoxImg src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png" />
                  )}
                </CardContent>
                <CardContent style={{ lineHeight: 2.0, color: '#4e3e51' }}>
                  <span style={{ color: appColors.primary, fontWeight: '500' }}>
                    Responsável:
                  </span>{' '}
                  {children.user.name} <br />
                  <span style={{ color: appColors.primary, fontWeight: '500' }}>
                    Gênero:
                  </span>{' '}
                  {translateGenre(children.genre)} <br />
                  <span style={{ color: appColors.primary, fontWeight: '500' }}>
                    Data de Nascimento:
                  </span>{' '}
                  {translateDate(children.birth_date)} <br />
                </CardContent>
              </Card>
            )}
          </Box>
        </Box>
      </div>
    </>
  );
};

ChildrenView.propTypes = {
  clientId: PropTypes.number.isRequired,
};

export default ChildrenView;
